// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OriginDestinationHorizontal-module__wrapper___WgqqT","wrapperVertical":"OriginDestinationHorizontal-module__wrapperVertical___JVGic"};